
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34792',
  depVersions: {
  "documents-public-ui": "static-1.34792",
  "atom": "static-1.5189",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2612",
  "client-types": "static-1.480",
  "cssUtils": "static-1.824",
  "customer-data-filters-ui": "static-1.40201",
  "customer-data-objects": "static-1.7792",
  "customer-data-property-utils": "static-1.8209",
  "documents-lib": "static-1.34797",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.346",
  "FormsCommonComponents": "static-1.86128",
  "FormUrlGenerator": "static-2.4836",
  "foundations-theming-specialty": "static-1.2261",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5707",
  "hs-test-utils": "static-1.8134",
  "hub-http": "static-1.6336",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11896",
  "HubStyleTokens": "static-2.11589",
  "I18n": "static-7.1638",
  "icons": "static-2.654",
  "jasmine-immutable": "static-1.3135",
  "jasmine-runner": "static-1.6572",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7267",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5511",
  "quartz": "static-1.7177",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16798",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5425",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8288",
  "reference-resolvers-lite": "static-1.8211",
  "reporting-data": "static-1.68043",
  "reporting-reports": "static-1.67721",
  "reporting-snowflake": "static-1.56661",
  "reporting-testing-lib": "static-1.9976",
  "reporting-visualizations": "static-1.60119",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9061",
  "sanitize": "static-1.4590",
  "sanitize-text": "static-1.8259",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1858",
  "signup-constants": "static-1.19126",
  "signup-ui-url-generator": "static-2.8171",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4873",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4873",
  "ui-addon-form-validation": "static-1.11104",
  "ui-asset-management-lib": "static-1.11180",
  "ui-images": "static-2.1182",
  "UIComponents": "static-3.8535",
  "usage-tracker": "static-1.7463",
  "usage-tracker-container": "static-1.7453",
  "usage-tracker-core": "static-1.7313",
  "viral-links-lib": "static-1.7182",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9775",
  "foundations-components": "static-1.8164",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.955",
  "quartz-core": "static-1.6396",
  "quick-fetch": "static-1.4001",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4771",
  "ui-addon-i18n": "static-1.11263",
  "ui-addon-upgrades": "static-9.18151",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3481",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3454",
  "quartz-webpack": "static-1.3401",
  "foundations-assets": "static-1.4987",
  "foundations-theming": "static-1.4545",
  "hub-http-shared-msw-handlers": "static-1.10250",
  "hubspotter-http": "static-1.4734",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7361",
  "crm-message-bus": "static-1.43286",
  "customer-data-filters-ui-msw-helpers": "static-1.22636",
  "customer-data-objects-ui-components": "static-1.13143",
  "customer-data-reference-ui-components": "static-1.13288",
  "customer-data-ui-utilities": "static-1.9939",
  "events-data-lib": "static-1.346",
  "framework-builder-read-service-client": "static-1.4087",
  "framework-data-schema-quick-fetch": "static-1.6911",
  "framework-data-schema-resolvers": "static-1.7006",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3670",
  "inbound-db-properties-service-client": "static-1.3929",
  "multi-account-reference-resolvers": "static-1.1096",
  "onboarding-tours": "static-1.16820",
  "reporting-datasets-permissions-lib": "static-1.14013",
  "ui-addon-teams": "static-1.21698",
  "quartz-auth": "static-1.852",
  "ui-business-units-lib": "static-1.9181",
  "usage-tracker-session-replay": "static-1.5149",
  "ai-components-ui-library": "static-1.9249",
  "ContentUtils": "static-1.68699",
  "customer-data-properties": "static-1.51970",
  "forms-ai-lib": "static-1.4500",
  "forms-utils-lib": "static-1.12801",
  "foundations-components-test-utils": "static-1.5647",
  "react-dnd-compat": "static-1.4729",
  "react-tinymce": "static-1.55551",
  "tinymce-config": "static-2.54677",
  "ui-gdpr-components": "static-1.10463",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3530",
  "HeadJS": "static-2.770",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3245",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.165",
  "ui-fonts": "static-1.851",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4439",
  "csstype": "static-1.50",
  "quartz-head": "static-1.842",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1657",
  "external-options-client-types": "static-1.4210",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.852",
  "frontend-preferences-client": "static-1.8041",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3814",
  "reporting-client-types": "static-1.2570",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25719",
  "hubspot-apollo-client": "static-1.4992",
  "foundations-components-legacy": "static-1.1189",
  "quartz-routing": "static-1.607",
  "hs-story-utils": "static-1.9537",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.338",
  "timezone-utils": "static-2.5357",
  "seat-types-lib": "static-1.273",
  "react-create-root-preference": "static-1.36",
  "bend-plugin-foundations-components": "static-1.4433",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2193",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.845",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.852",
  "quartz-tracking": "static-1.556",
  "trellis-components": "static-1.2212",
  "bend-plugin-chirp-manifest": "static-1.181",
  "chirp-fetch": "static-1.2002",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6091",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4165",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-foundations-theming": "static-1.3028",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1173",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.288",
  "pulse": "static-1.717",
  "conditional-properties-service-client": "static-1.3881",
  "crm-pipelines-api-client-types": "static-1.4220",
  "fdsr-migration-layer": "static-1.125",
  "multi-currency-client-types": "static-1.3774",
  "getting-started-shared-tasks": "static-1.18735",
  "growth-data-modal": "static-1.5616",
  "growth-onboarding-confetti": "static-1.3179",
  "growth-onboarding-next-action-utils": "static-1.2251",
  "navigation-components": "static-1.18297",
  "onboarding-tours-client": "static-1.5034",
  "onboarding-tours-utils": "static-1.886",
  "ui-shepherd-react": "static-3.10361",
  "ui-shepherd-tracker": "static-1.7742",
  "ui-universal-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "user-context": "static-1.5223",
  "hubspotter-http-shared-msw-handlers": "static-1.10248",
  "magpie-lib": "static-1.5626",
  "navigation-messaging": "static-1.7624",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21846",
  "copilot-toolkit": "static-1.11435",
  "cms-field-types": "static-1.4929",
  "content-icons-ui": "static-1.2258",
  "integrations-lib": "static-1.16526",
  "calling-global-api": "static-1.64913",
  "calling-internal-common": "static-1.31424",
  "calling-lifecycle-internal": "static-1.66295",
  "calling-lifecycle-messages": "static-1.58589",
  "commerce-products-lib": "static-1.9988",
  "crm-links": "static-1.6422",
  "customer-data-properties-shared-msw-handlers": "static-1.9577",
  "file-manager-components": "static-1.23950",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4301",
  "meetings-icalendar-utils-lib": "static-1.747",
  "object-builder-ui-client": "static-1.49145",
  "pipeline-validation-client-types": "static-1.4049",
  "property-value-citations": "static-1.2584",
  "smart-property-lib": "static-1.7818",
  "tiered-pricing": "static-1.1518",
  "ui-addon-iframeable": "static-1.9181",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20033",
  "tinymce-themes": "static-1.56647",
  "data-token-picker": "static-1.16614",
  "hub-http-contrib": "static-1.3157",
  "interframe": "static-3.4874",
  "tinymce-data": "static-1.40762",
  "tinymce-plugins": "static-1.57791",
  "ui-addon-sales-email": "static-1.5324",
  "onboarding-scopes": "static-1.6574",
  "ui-addon-opt": "static-4.8475",
  "apollo-link-hub-http": "static-2.4765",
  "hubspot-apollo-cache": "static-1.451",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.287",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1055",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6094",
  "unified-auth-core-lib": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "event-emitter": "static-1.1063",
  "bend-plugin-pulse": "static-1.220",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2162",
  "growth-onboarding-next-action-components": "static-1.2279",
  "user-context-client": "static-1.4694",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5086",
  "nest": "static-1.345",
  "reactive-lib": "static-1.839",
  "simple-logging-lib": "static-1.3162",
  "getting-started-shared-tasks-store": "static-1.17853",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1120",
  "integrations-error-boundary-lib": "static-1.13941",
  "integrations-tracking-lib": "static-1.5720",
  "native-integrations-shared-strings": "static-1.7896",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10476",
  "rxjs": "static-5.10",
  "unified-auth": "static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "calling-error-reporting": "static-1.31431",
  "shared-worker-versioning": "static-1.11149",
  "calling-usage-tracker": "static-1.6657",
  "voice-sms-access-library": "static-1.1440",
  "customer-data-tracking": "static-1.7001",
  "commerce-permissions": "static-1.890",
  "products-iframe-lib": "static-1.8251",
  "products-ui-components-shared-msw-handlers": "static-1.10632",
  "location-customization-utils-lib": "static-1.9601",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4264",
  "video-components-external": "static-1.11652",
  "video-data-lib": "static-1.35310",
  "data-agent-kit": "static-1.388",
  "feedback-loader": "static-1.29516",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10333",
  "fsm": "static-1.3842",
  "policy-lib": "static-1.6896",
  "react-colorpicker": "static-2.10321",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10396",
  "FileManagerLib": "static-1.39590",
  "NamespacedHubStyle": "static-2.9137",
  "FileManagerCore": "static-1.39449",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7939",
  "layout-dnd-components": "static-1.12672",
  "layout-dnd-utils": "static-1.11647",
  "react-codemirror": "static-1.10741",
  "ui-addon-emoji-picker": "static-1.10001",
  "ui-brand-identity-lib": "static-1.15701",
  "adobe-sign-auth-lib": "static-1.16",
  "ads-unified-auth-lib": "static-1.381",
  "google-sheets-integration-lib": "static-1.580",
  "microsoft-drive-integration-lib": "static-1.712",
  "surveymonkey-integration-lib": "static-1.36",
  "slack-ui-library": "static-1.10510",
  "InboxConnectUtils": "static-4.15115",
  "meetings-connect-utils-lib": "static-1.7719",
  "breeze-engine-core": "static-1.398",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3131",
  "calling-orchestration-schema": "static-1.36217",
  "sales-views-client-types": "static-1.4371",
  "crm-record-cards-service-types": "static-1.3671",
  "content-media-composition-data-lib": "static-1.12667",
  "content-media-compositions": "static-2.16674",
  "media-bridge-lib": "static-1.19128",
  "trellis-story-utils": "static-1.4625",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6095",
  "FileManagerImages": "static-1.37101",
  "video-components": "static-1.13654",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4649",
  "video-embed": "static-1.36144",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8818",
  "ui-coaching-tips": "static-1.28882",
  "ContentData": "static-1.68774",
  "layout-data-lib": "static-1.9972",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22340",
  "outpost": "static-1.4284",
  "growth-onboarding-feedback-components": "static-1.6692",
  "advanced-menus-core": "static-1.15321",
  "advanced-menus-lib": "static-1.12234",
  "ExportDialog": "static-6.10494",
  "ui-memberships-settings-lib": "static-1.34353",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15320",
  "simple-menus-lib": "static-1.16837"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34792",
  "atom": "/atom/static-1.5189",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2612",
  "client-types": "/client-types/static-1.480",
  "cssUtils": "/cssUtils/static-1.824",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40201",
  "customer-data-objects": "/customer-data-objects/static-1.7792",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8209",
  "documents-lib": "/documents-lib/static-1.34797",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.346",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86128",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4836",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2261",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5707",
  "hs-test-utils": "/hs-test-utils/static-1.8134",
  "hub-http": "/hub-http/static-1.6336",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11896",
  "HubStyleTokens": "/HubStyleTokens/static-2.11589",
  "I18n": "/I18n/static-7.1638",
  "icons": "/icons/static-2.654",
  "jasmine-immutable": "/jasmine-immutable/static-1.3135",
  "jasmine-runner": "/jasmine-runner/static-1.6572",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7267",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5511",
  "quartz": "/quartz/static-1.7177",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16798",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5425",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8288",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8211",
  "reporting-data": "/reporting-data/static-1.68043",
  "reporting-reports": "/reporting-reports/static-1.67721",
  "reporting-snowflake": "/reporting-snowflake/static-1.56661",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9976",
  "reporting-visualizations": "/reporting-visualizations/static-1.60119",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9061",
  "sanitize": "/sanitize/static-1.4590",
  "sanitize-text": "/sanitize-text/static-1.8259",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1858",
  "signup-constants": "/signup-constants/static-1.19126",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8171",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4873",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4873",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11104",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11180",
  "ui-images": "/ui-images/static-2.1182",
  "UIComponents": "/UIComponents/static-3.8535",
  "usage-tracker": "/usage-tracker/static-1.7463",
  "usage-tracker-container": "/usage-tracker-container/static-1.7453",
  "usage-tracker-core": "/usage-tracker-core/static-1.7313",
  "viral-links-lib": "/viral-links-lib/static-1.7182",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9775",
  "foundations-components": "/foundations-components/static-1.8164",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.955",
  "quartz-core": "/quartz-core/static-1.6396",
  "quick-fetch": "/quick-fetch/static-1.4001",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4771",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11263",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18151",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3481",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3454",
  "quartz-webpack": "/quartz-webpack/static-1.3401",
  "foundations-assets": "/foundations-assets/static-1.4987",
  "foundations-theming": "/foundations-theming/static-1.4545",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10250",
  "hubspotter-http": "/hubspotter-http/static-1.4734",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7361",
  "crm-message-bus": "/crm-message-bus/static-1.43286",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22636",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13143",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13288",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9939",
  "events-data-lib": "/events-data-lib/static-1.346",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4087",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6911",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7006",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3670",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3929",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1096",
  "onboarding-tours": "/onboarding-tours/static-1.16820",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14013",
  "ui-addon-teams": "/ui-addon-teams/static-1.21698",
  "quartz-auth": "/quartz-auth/static-1.852",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9181",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5149",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9249",
  "ContentUtils": "/ContentUtils/static-1.68699",
  "customer-data-properties": "/customer-data-properties/static-1.51970",
  "forms-ai-lib": "/forms-ai-lib/static-1.4500",
  "forms-utils-lib": "/forms-utils-lib/static-1.12801",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5647",
  "react-dnd-compat": "/react-dnd-compat/static-1.4729",
  "react-tinymce": "/react-tinymce/static-1.55551",
  "tinymce-config": "/tinymce-config/static-2.54677",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10463",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3530",
  "HeadJS": "/HeadJS/static-2.770",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3245",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.165",
  "ui-fonts": "/ui-fonts/static-1.851",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4439",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.842",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1657",
  "external-options-client-types": "/external-options-client-types/static-1.4210",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.852",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8041",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3814",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25719",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4992",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1189",
  "quartz-routing": "/quartz-routing/static-1.607",
  "hs-story-utils": "/hs-story-utils/static-1.9537",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.338",
  "timezone-utils": "/timezone-utils/static-2.5357",
  "seat-types-lib": "/seat-types-lib/static-1.273",
  "react-create-root-preference": "/react-create-root-preference/static-1.36",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4433",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2193",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.852",
  "quartz-tracking": "/quartz-tracking/static-1.556",
  "trellis-components": "/trellis-components/static-1.2212",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.181",
  "chirp-fetch": "/chirp-fetch/static-1.2002",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6091",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4165",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3028",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1173",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.288",
  "pulse": "/pulse/static-1.717",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3881",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4220",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.125",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3774",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18735",
  "growth-data-modal": "/growth-data-modal/static-1.5616",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3179",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2251",
  "navigation-components": "/navigation-components/static-1.18297",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5034",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.886",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10361",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7742",
  "ui-universal-auth": "/ui-universal-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "user-context": "/user-context/static-1.5223",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10248",
  "magpie-lib": "/magpie-lib/static-1.5626",
  "navigation-messaging": "/navigation-messaging/static-1.7624",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21846",
  "copilot-toolkit": "/copilot-toolkit/static-1.11435",
  "cms-field-types": "/cms-field-types/static-1.4929",
  "content-icons-ui": "/content-icons-ui/static-1.2258",
  "integrations-lib": "/integrations-lib/static-1.16526",
  "calling-global-api": "/calling-global-api/static-1.64913",
  "calling-internal-common": "/calling-internal-common/static-1.31424",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66295",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58589",
  "commerce-products-lib": "/commerce-products-lib/static-1.9988",
  "crm-links": "/crm-links/static-1.6422",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9577",
  "file-manager-components": "/file-manager-components/static-1.23950",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4301",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.747",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49145",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4049",
  "property-value-citations": "/property-value-citations/static-1.2584",
  "smart-property-lib": "/smart-property-lib/static-1.7818",
  "tiered-pricing": "/tiered-pricing/static-1.1518",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9181",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20033",
  "tinymce-themes": "/tinymce-themes/static-1.56647",
  "data-token-picker": "/data-token-picker/static-1.16614",
  "hub-http-contrib": "/hub-http-contrib/static-1.3157",
  "interframe": "/interframe/static-3.4874",
  "tinymce-data": "/tinymce-data/static-1.40762",
  "tinymce-plugins": "/tinymce-plugins/static-1.57791",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5324",
  "onboarding-scopes": "/onboarding-scopes/static-1.6574",
  "ui-addon-opt": "/ui-addon-opt/static-4.8475",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4765",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.451",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.287",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1055",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6094",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "event-emitter": "/event-emitter/static-1.1063",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.220",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2162",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2279",
  "user-context-client": "/user-context-client/static-1.4694",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5086",
  "nest": "/nest/static-1.345",
  "reactive-lib": "/reactive-lib/static-1.839",
  "simple-logging-lib": "/simple-logging-lib/static-1.3162",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17853",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1120",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13941",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5720",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7896",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10476",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1-apastayalka_hubspot-critsit-appid-string-rootcause.5",
  "calling-error-reporting": "/calling-error-reporting/static-1.31431",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11149",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6657",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1440",
  "customer-data-tracking": "/customer-data-tracking/static-1.7001",
  "commerce-permissions": "/commerce-permissions/static-1.890",
  "products-iframe-lib": "/products-iframe-lib/static-1.8251",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10632",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9601",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4264",
  "video-components-external": "/video-components-external/static-1.11652",
  "video-data-lib": "/video-data-lib/static-1.35310",
  "data-agent-kit": "/data-agent-kit/static-1.388",
  "feedback-loader": "/feedback-loader/static-1.29516",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10333",
  "fsm": "/fsm/static-1.3842",
  "policy-lib": "/policy-lib/static-1.6896",
  "react-colorpicker": "/react-colorpicker/static-2.10321",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10396",
  "FileManagerLib": "/FileManagerLib/static-1.39590",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9137",
  "FileManagerCore": "/FileManagerCore/static-1.39449",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7939",
  "layout-dnd-components": "/layout-dnd-components/static-1.12672",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11647",
  "react-codemirror": "/react-codemirror/static-1.10741",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10001",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15701",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.16",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.381",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.580",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.712",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.36",
  "slack-ui-library": "/slack-ui-library/static-1.10510",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15115",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7719",
  "breeze-engine-core": "/breeze-engine-core/static-1.398",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3131",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36217",
  "sales-views-client-types": "/sales-views-client-types/static-1.4371",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12667",
  "content-media-compositions": "/content-media-compositions/static-2.16674",
  "media-bridge-lib": "/media-bridge-lib/static-1.19128",
  "trellis-story-utils": "/trellis-story-utils/static-1.4625",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6095",
  "FileManagerImages": "/FileManagerImages/static-1.37101",
  "video-components": "/video-components/static-1.13654",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4649",
  "video-embed": "/video-embed/static-1.36144",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8818",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28882",
  "ContentData": "/ContentData/static-1.68774",
  "layout-data-lib": "/layout-data-lib/static-1.9972",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22340",
  "outpost": "/outpost/static-1.4284",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6692",
  "advanced-menus-core": "/advanced-menus-core/static-1.15321",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12234",
  "ExportDialog": "/ExportDialog/static-6.10494",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34353",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15320",
  "simple-menus-lib": "/simple-menus-lib/static-1.16837"
}
};
